module.exports = __webpack_public_path__ + "img/cockfight icon 1.012c6c63.png";